module.exports = __webpack_public_path__ + "img/airbnb.ede60847.png";